import {
  Directive,
  ElementRef,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UserService } from '@olymp/shared';
import { IRole } from '../model/role';
import { doesUserHasPermission } from '../utils/permission';

@Directive({
  selector: '[uiPermission]',
  standalone: true,
})
export class PermissionDirective {
  permissions = input<string[] | undefined>(undefined, {
    alias: 'uiPermission',
  });

  private readonly userService = inject(UserService);

  private readonly viewContainer = inject(ViewContainerRef);

  private readonly templateRef = inject(TemplateRef<ElementRef<HTMLElement>>);

  private hasView = false;

  constructor() {
    effect(() => {
      const currentUserPermissions = this.userService.user()?.roles;
      const requiredPermissions = this.permissions();
      this.checkPermissions(currentUserPermissions, requiredPermissions);
    });
  }

  private checkPermissions(
    currentUserPermissions: IRole[] | undefined,
    requiredPermissions: string[] | undefined,
  ): void {
    if (!currentUserPermissions) {
      if (this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
      return;
    }

    const isAllowed = doesUserHasPermission(
      currentUserPermissions,
      requiredPermissions,
    );

    if (isAllowed && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!isAllowed && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
